import { resolveSafePostLoginPath } from "./heycoachSubscription.js";

export function resolvePostAuthDestination({ role, postLoginPath, fromPathname }) {
  return resolveSafePostLoginPath(fromPathname, role) ?? postLoginPath;
}

/** Sync AuthContext after sign-in and navigate to the role-appropriate home. */
export async function redirectAfterAuth({ refetch, navigate, fromPathname }) {
  const { postLoginPath, role } = await refetch({ silent: true });
  const dest = resolvePostAuthDestination({ role, postLoginPath, fromPathname });
  navigate(dest, { replace: true });
}
